<template>
  <div class="bg-secondary pb-5">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>

    <div v-if="consultantstatus && consultantstatus.can_do_survey === '0' && consultantstatus.can_do_elearning === '0'"
      class="my-5">
      <LearningHub />
    </div>

    <div class="mx-auto container-xl">
      <div v-if="consultantstatus && consultantstatus.can_do_survey === '1'">
        <div class="surveylist">
          <div id="my-surveys" class="title-area">
            <b-row class="mt-5">
              <div class="col-md-8 col-12">
                <h1 class="page-title h2">
                  Welcome {{ user.first_name }} {{ user.family_name }}
                  <!-- TODO: Update screentext -->
                </h1>
                <div>
                  <p v-html="intro_text">
                  </p>
                  <!-- TODO: Update screentext -->
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div>
                  <strong class="d-block mb-2">Quick links</strong>
                  <a class="d-block mb-2" href="/tutorials">Tutorials</a>
                  <a class="d-block mb-2" href="mailto:gdq@gdq.se">Support</a>
                  <!-- TODO: Update screentext? -->
                </div>
              </div>
            </b-row>
          </div>
        </div>

        <div class="island-grid" no-gutters="true">
          <div class="island">
            <div class="island-header">
              <div class="island-title d-flex justify-content-between align-items-center">
                <a href="/surveys">
                  <i class="fa-regular fa-square-poll-vertical"></i>
                  <h2>My surveys</h2>
                  <i class="fa-regular fa-square-arrow-up-right"></i>
                </a>
                <b-link to="/create">
                  <b-button type="secondary"><i class="fa fa-regular fa-plus mr-2"></i>New survey</b-button>
                </b-link>
              </div>
            </div>
            <div class="island-table">
              <Surveys />
            </div>
          </div>

          <div class="island">
            <div class="island-header">
              <div class="island-title d-flex justify-content-between align-items-center">
                <a href="/foldersgroups">
                  <i class="fa-regular fa-square-poll-vertical"></i>
                  <h2>My folders and groups</h2>
                  <i class="fa-regular fa-square-arrow-up-right"></i>
                </a>
                <b-link to="/create/group">
                  <b-button type="secondary"><i class="fa fa-regular fa-plus mr-2"></i>New group</b-button>
                </b-link>
              </div>
            </div>
            <div class="island-table">
              <Folders @reload-dashboard="reloadDashboard"/>
            </div>
          </div>

          <div class="island">
            <div class="island-header">
              <div class="island-title d-flex justify-content-between align-items-center">
                <a href="/reports">
                  <i class="fa-regular fa-file-chart-column"></i>
                  <h2>My aggregated reports</h2>
                  <i class="fa-regular fa-square-arrow-up-right"></i>
                </a>
                <b-link to="/aggregatedreports">
                  <b-button type="secondary"><i class="fa fa-regular fa-plus mr-2"></i>New report</b-button>
                </b-link>
              </div>
            </div>
            <div class="island-table">
              <MyAggregatedReports />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Surveys from './dashboard/Surveys.vue'
import Folders from './dashboard/Folders.vue'
// import PopupBubble from './PopupBubble'
import LearningHub from './LearningHub.vue'
import MyAggregatedReports from './dashboard/MyAggregatedReports.vue'

export default {
  name: 'dashboard',
  components: {
    Navbar,
    Surveys,
    Folders,
    // PopupBubble,
    MyAggregatedReports,
    LearningHub
  },
  data: function () {
    return {
      screen_id: 1,
      screentexts: [],
      intro_text: 'Welcome to <strong>My GDQ Management</strong>. Here, you can easily create, organise, and manage your surveys and reports, all in one place. Set up a clear folder structure to gain an enhanced overview of your groups and surveys. Track the progress of ongoing or scheduled surveys, send timely reminders, add new participants, and export detailed reports.',
      profile: this.$store.state.profile,
      user: this.$store.state.user,
      tabIndex: 0,
      thisurl: window.location.href,
      surveycount_1: 0,
      surveycount_2: 0,
      surveycount_3: 0,
      surveycount_4: 0
    }
  },
  computed: {
    promptupdate: function () {
      return true
    },
    consultantstatus: function () {
      const consultantstatus = this.$store.state.consultantstatuses.find(s => s.id === this.profile.consultantstatus_id)
      if (consultantstatus) {
        const beh = consultantstatus
      }
      return consultantstatus
    }
  },
  async created () {
    this.$store.dispatch('group_clear')
    this.$store.dispatch('survey_clear')
    this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: 0 })
    await this.profile_get()
    this.user_usergroups_get()
    this.countries_get()
    this.consultantstatuses_get()
    this.formoptions_get()
    this.screentexts_get()
  },
  methods: {
    reloadDashboard () {
      this.$store.dispatch('group_clear')
      this.$store.dispatch('survey_clear')
      this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: 0 })
      this.profile_get()
      this.user_usergroups_get()
      this.countries_get()
      this.consultantstatuses_get()
      this.formoptions_get()
      this.screentexts_get()
    },
    profile_get () {
      return this.$store.dispatch('profile_fetch', {})
    },
    user_usergroups_get () {
      this.$store.dispatch('user_usergroups_fetch')
        .then((resp) => {
          return resp
        })
    },
    countries_get () {
      this.$store.dispatch('countries_fetch')
    },
    consultantstatuses_get () {
      this.$store.dispatch('consultantstatuses_fetch')
    },
    formoptions_get: function () {
      this.$store.dispatch('formoptions_fetch')
    },
    screentexts_get: function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
          if (this.screentexts[180]) {
            this.intro_text = this.screentexts[180].element_text
          }
        })
    }
  }
}
</script>
<style scoped></style>
